import { SystemService } from './system.service';
import { BLocalStorageService } from 'app/service/bLocalStorage.service';
import * as firebase from 'firebase';
import { PubSubService } from './pubSub.service';
import { HttpClient } from '@angular/common/http';
import { BSessionStorage } from './bSessionStorage.service';
import { Router } from '@angular/router';
import { BHTTPLoader } from './bHTTPLoader';
import { environment } from '../../environments/environment.prod';
var NotificationService = (function () {
    function NotificationService(localStorageService, pubSubService, http, router, bHttpLoader) {
        var _this = this;
        this.localStorageService = localStorageService;
        this.pubSubService = pubSubService;
        this.http = http;
        this.router = router;
        this.bHttpLoader = bHttpLoader;
        this.systemService = SystemService.getInstance();
        this.firebaseSenderId = this.systemService.getVal('firebaseSenderId');
        this.isNotificationEnabled = this.systemService.getVal('isNotificationEnabled');
        this.appName = this.systemService.getVal('appName');
        this.deviceType = this.systemService.deviceType;
        this.sessionStorage = new BSessionStorage();
        this.loginSubscribe = this.pubSubService.$sub('loginComplete', function () {
            _this.enableNotification();
        });
    }
    NotificationService.prototype.ngOnInit = function () {
    };
    NotificationService.prototype.enableNotification = function () {
        var _this = this;
        document.addEventListener('deviceready', function (event) {
            if (_this.isNotificationEnabled) {
                // if (this.deviceType && this.deviceType != 'browser') {
                //   this.deviceType = this.systemService.deviceType;
                _this.checkPermission().then(function (res) {
                    if (res) {
                        _this.initializeNotifications();
                    }
                    // });
                });
                // }
            }
        });
        if (this.isNotificationEnabled) {
            if (this.deviceType && this.deviceType == 'browser' && window['Notification']) {
                this.initialiseWebPush();
            }
        }
    };
    NotificationService.prototype.initialiseWebPush = function () {
        var __this = this;
        var messaging = firebase.messaging();
        messaging.requestPermission()
            .then(function () {
            return messaging.getToken();
        })
            .then(function (token) {
            if (token) {
                __this.sendRegDetails(token);
            }
        })
            .catch(function (err) {
            __this.bHttpLoader.alertError(err);
            // console.log('Error Occured.', err);
        });
        messaging.onMessage(function (payload) {
            if (payload['notification']) {
                var notificationObj = payload['notification'];
                var options = {
                    body: notificationObj.body,
                    icon: notificationObj.icon
                };
                // console.log('deviceType', this.deviceType);
                // creating a native browser message
                var notificationUI = new Notification(notificationObj.title, options);
                notificationUI.onclick = function () {
                    window.focus(); // window is focused when the user clicks the notification using this
                };
            }
        });
    };
    NotificationService.prototype.checkPermission = function () {
        var _this = this;
        // Android & iOS only
        // Checks whether the push notification permission has been granted.
        return new Promise(function (resolve) {
            if (_this.deviceType === 'Android' || _this.deviceType === 'iOS') {
                PushNotification.hasPermission(function (data) {
                    return resolve(data.isEnabled);
                });
            }
            else {
                return resolve(true);
            }
        });
    };
    NotificationService.prototype.initializeNotifications = function () {
        var _this = this;
        var push = window['PushNotification'].init({
            android: {
                senderID: this.firebaseSenderId
            },
            ios: {
                alert: "true",
                badge: "true",
                sound: "true",
                senderID: this.firebaseSenderId
            },
        });
        push.on('registration', function (data) {
            // data.registrationId
            // console.log(data.registrationId);
            _this.sendRegDetails(data.registrationId);
        });
        push.on('notification', function (data) {
            // data.message,
            // data.title,
            // data.count,
            // data.sound,
            // data.image,
            // data.additionalData
            // window['cordova'].plugins.notification.local.schedule({
            //   title: data.title,
            //   text: data.message,
            //   sound: data.sound,
            //   at: new Date().getTime()
            // });
        });
        push.on('error', function (e) {
            // e.message
            console.error(e);
        });
    };
    NotificationService.prototype.sendRegDetails = function (registrationId) {
        this.localStorageService.setValue('registrationId', registrationId);
        var url = this.systemService.getTenantUrl() + 'notification/' + this.systemService.getVal('appName') + '/register';
        this.http.post(url, {
            'key': this.sessionStorage.getValue('userObj')['userKey'],
            'uuid': this.localStorageService.getValue('uuid'), 'fbregid': registrationId
        }).subscribe(function (result) {
            // this.pubSubService.$pub('FBRegComp');
        }, function (error) {
            console.log(error);
        });
    };
    NotificationService.prototype.databaseInitForServiceWorker = function () {
        var open = indexedDB.open('bhive_omni_firebase_db', 1);
        open.onupgradeneeded = function () {
            var db = open.result;
            var store = db.createObjectStore('bhive_omni_firebase_db_store');
        };
        open.onsuccess = function () {
            // Start a new transaction
            var db = open.result;
            var tx = db.transaction('bhive_omni_firebase_db_store', 'readwrite');
            var store = tx.objectStore('bhive_omni_firebase_db_store');
            // store.put(environment.properties);
            store.add(environment.properties.firebaseSenderId, 'firebaseSenderId');
            if (environment.properties.messagingSenderId) {
                store.add(environment.properties.messagingSenderId, 'messagingSenderId');
            }
            tx.oncomplete = function () {
                db.close();
            };
        };
    };
    NotificationService.prototype.ngOnDestroy = function () {
        this.loginSubscribe.unSubscribe();
    };
    return NotificationService;
}());
export { NotificationService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/notification.service.ts.pre-build-optimizer.js